import { useContext, useEffect, useState } from 'react'
import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { GlobalStoreContext } from 'Components/store'

function useFetchCollected({
  id,
  collected,
}: {
  id?: number | string
  collected?: boolean
}) {
  const [curCollected, setCurCollected] = useState(collected)

  const { state } = useContext(GlobalStoreContext)

  const userId = state.userData?.user_id

  useEffect(() => {
    if (!userId) {
      return
    }
    fetch(
      getUrl(
        `/motor/pc/common/article/is_collect?${serializeObject({
          user_id: userId,
          group_id: id,
        })}`
      )
    ).then((res) => {
      if (res?.status === 0) {
        setCurCollected(res.data?.is_collect)
      }
    })
  }, [id, userId])

  return curCollected
}

export default useFetchCollected
